import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const COMPLIANCE_REQUEST_INSTANCES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'COMPLIANCE_REQUEST_INSTANCES'
);
export const COMPLIANCE_REQUEST_INSTANCES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	COMPLIANCE_REQUEST_INSTANCES_CRUD_ACTION_CONSTANTS
);
